import React from 'react';
import PropTypes from 'prop-types';
import { LoadableComponent } from 'components';

let ClientsMapView = LoadableComponent({
  loader: () => import('./clients-map-view'),
  webpackRequireWeakId: () => require.resolveWeak('./clients-map-view'),
});

export default class ClientsMapViewLoadable extends React.Component {
  render() {
    console.log('Rendering Map Loadable View')
    return (
      <ClientsMapView {...this.props} />
    )
  }
}



// WEBPACK FOOTER //
// ./src/browser/components/clients/map/clients-map-view-loadable.js